import { render, staticRenderFns } from "./AdminDistUsers.vue?vue&type=template&id=5befa562"
import script from "./AdminDistUsers.vue?vue&type=script&lang=js"
export * from "./AdminDistUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports